<template>
  <v-form>
    <v-row class="mb-2">

      <v-col cols="12" md="6">
        <v-text-field
          name="rawMaterialName"
          outlined
          dense
          label="Raw Material Name *"
          v-model="record.Name"
          type="text"
          autocomplete="off"
        ></v-text-field>
      </v-col>


      <v-col cols="12" md="3">
        <v-autocomplete
          autocomplete="off"
          name="rawCategoryCreate"
          hide-details
          dense
          outlined
          v-model="record.i_t_m1_s_id"
          :items="categories"
          label="Category"
          item-text="Name"
          item-value="id"
        >
          <template v-slot:no-data>
            <v-row align="center" justify="center">
              <v-btn class="ma-2" color="accent" dark small elevation="0" @click="categoryModal()">
                <v-icon left>mdi-plus</v-icon>Create Category
              </v-btn>
            </v-row>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field
          hide-details
          outlined
          dense
          label="Buying Price"
          v-model="record.BuyingPrice"
          type="number"
          autocomplete="off"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field
          hide-details
          outlined
          dense
          label="Re Order Level"
          v-model="record.ReOrder"
          type="text"
          autocomplete="off"
        ></v-text-field>
      </v-col>

    </v-row>

    <v-divider></v-divider>

    <v-row>
      <v-col cols="12">
        <v-checkbox label="Define units of measure" v-model="uomSetup"></v-checkbox>
      </v-col>
    </v-row>

    <v-row v-if="uomSetup == true || manualStatus == false">
      <v-col cols="12" md="3">
        <v-autocomplete
          name="productBaseUom"
          outlined
          dense
          v-model="record.IUoMEntry"
          :items="uom"
          item-text="UomName"
          item-value="id"
          label="Base / inventory UOM (smallest unit)"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete
          name="productPurchaseUom"
          outlined
          dense
          v-model="record.PUoMEntry"
          :items="uom"
          item-text="UomName"
          item-value="id"
          label="Default Purchase UOM"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete
          name="SUoMEntry"
          dense
          outlined
          v-model="record.SUoMEntry"
          :items="uom"
          item-text="UomName"
          item-value="id"
          label="Default Sales UOM"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete
          outlined
          dense
          readonly
          filled
          v-model="record.IUoMEntry"
          :items="uom"
          item-text="UomName"
          item-value="id"
          label="Inventory Uom"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-row class="mt-2" v-show="uomSetup || manualStatus == false">
      <v-col cols="12">
        <v-btn text color="accent" class="float-right" @click.native="uomDialog = true">
          <v-icon>mdi-plus</v-icon>Add Uom
        </v-btn>
      </v-col>

      <v-col cols="12">
        <v-data-table
          :items-per-page="2000"
          :headers="headers"
          :items="uomArray"
          :mobile-breakpoint="0"
        >
          <!-- action template -->
          <template v-slot:item.uomName="{ item }">
            <span v-show="docCreate == true">{{ item.uomName }}</span>
            <span v-show="docCreate == false">{{ item.uomentry && item.uomentry.UomName }}</span>
          </template>
          <!-- end -->

          <!-- action template -->
          <template v-slot:item.PackSize="{ item }">
            <span v-show="docCreate == true">{{ item.PackSize }}</span>
            <span v-show="docCreate == false">{{ item.BaseQty }}</span>
          </template>
          <!-- end -->

          <!-- action template -->
          <template v-slot:item.action="{ item }">
            <v-btn v-show="docCreate == true" color="red" text icon @click="deleteUom(item)">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-btn v-show="docCreate == false" color="primary" text icon>
              <v-btn color="accent" text icon @click="openEditModal(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </v-btn>
          </template>
          <!-- end -->
        </v-data-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="accent"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn v-else color="accent" @click="updateData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>

    <!-- category quick add dialog -->
    <v-dialog v-model="categoryDialog" max-width="650px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create Category</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="categoryDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <category-editor :initial="newItem" @data="saveCategory"></category-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- brand quick add dialog -->
    <v-dialog v-model="brandDialog" max-width="650px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create Brand</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="brandDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <brand-editor :initial="newItem" @data="saveBrand"></brand-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- Balance dialog -->
    <v-dialog v-model="uomDialog" max-width="850">
      <v-card>
        <v-toolbar dense color="accent" dark>
          <v-toolbar-title>Add Uom Setup</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="uomDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid class="subtitle-2 text--primary">
            <v-row>
              <v-col cols="12" md="4">
                <v-autocomplete
                  outlined
                  name="newDefUomEntry"
                  v-model="uomItem.uomEntry"
                  :items="uom"
                  item-text="UomName"
                  item-value="id"
                  label="UoM Name"
                  @change="checkUom(uomItem.uomEntry)"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  hide-details
                  outlined
                  dense
                  label="Buying Price"
                  v-model="uomItem.BuyingPrice"
                  type="number"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  hide-details
                  outlined
                  dense
                  label="Wholesale Price"
                  v-model="uomItem.WholesalePrice"
                  type="number"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  hide-details
                  outlined
                  dense
                  label="Retail Price"
                  v-model="uomItem.RetailPrice"
                  type="number"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  hide-details
                  outlined
                  dense
                  label="Least Selling Price"
                  v-model="uomItem.SellingPrice"
                  type="number"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  hide-details
                  outlined
                  dense
                  :filled="record.IUoMEntry == uomItem.uomEntry ? true : false"
                  :readonly="record.IUoMEntry == uomItem.uomEntry ? true : false"
                  label="Pack Size"
                  v-model="uomItem.PackSize"
                  type="number"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-btn v-if="docCreate == true" color="primary" @click="addUom" :loading="loader">
                  <v-icon left>mdi-plus</v-icon>Add Uom
                </v-btn>

                <v-btn v-if="docCreate == false" color="primary" @click="addNewUom" :loading="loader">
                  <v-icon left>mdi-plus</v-icon>Add Uom
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of balance modal-->

       <!-- editing dialog -->
       <v-dialog v-model="editingDialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="primary" dark>
              <v-toolbar-title>Edit Group Definition</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="editingDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="12">
                    <v-autocomplete
                      name="newDefUomEntry"
                      v-model="uomItem.UomEntry"
                      :items="uom"
                      item-text="UomName"
                      item-value="id"
                      label="Uom Name"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-text-field
                      label="Buying Price"
                      outlined
                      dense
                      v-model="uomItem.BuyingPrice"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-text-field
                      label="Retail Price"
                      outlined
                      dense
                      v-model="uomItem.RetailPrice"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-text-field
                      label="Wholesale Price"
                      outlined
                      dense
                      v-model="uomItem.WholesalePrice"
                    ></v-text-field>
                  </v-col>


                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-text-field
                      label="Least Selling Price"
                      outlined
                      dense
                      v-model="uomItem.SellingPrice"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-text-field
                    :filled="record.IUoMEntry == uomItem.uomEntry ? true : false"
                    :readonly="record.IUoMEntry == uomItem.uomEntry ? true : false"
                      label="Pack Size"
                      outlined
                      dense
                      v-model="uomItem.BaseQty"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="accent" @click="updateDef" :loading="loader">
                      <v-icon left>mdi-content-save</v-icon> Update
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of editing dialog -->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
import CategoryEditor from "@/components/subscriber/products/categories/_components/quick-editor.vue";
import BrandEditor from "@/components/subscriber/products/brands/_components/quick-editor.vue";
export default {
  components: {
    CategoryEditor,
    BrandEditor
  },
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    uomSetup: false,
    uomItem: {},
    uomArray: [],
    owners: [],
    uomDialog: false,
    searchingProduct: true,
    enableCreate: true,
    categoryDialog: false,
    brandDialog: false,
    newItem: {},
    editItem: {},
    editingDialog: false,
    loader: false,
    PriceUnit: null,
    categories: [],
    industries: [],
    showPricing: false,
    manualStatus: false,
    activeUom: null,
    uom: [],
    uoms: [],
    ougp: [],
    brands: [],
    stores: [],
    vendors: [],
    store: null,
    date: new Date().toISOString().substr(0, 10),
    itemTypes: [
      { name: "Inventory", value: "I" },
      { name: "Service Item", value: "S" },
      { name: "Delivery Charges", value: "C" }
    ],
    headers: [
      { text: "Uom Unit", value: "uomName" },
      { text: "Buying Price", value: "BuyingPrice" },
      { text: "Retail Price", value: "RetailPrice" },
      { text: "WholesalePrice", value: "WholesalePrice" },
      { text: "Least Price", value: "SellingPrice" },
      { text: "Pac size", value: "PackSize" },
      { text: "Action", value: "action" }
    ]
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    init(val) {
      if (this.docCreate == false) {
        if (val.ugpentry) {
          const manualType = val.ugpentry.IsManual;
          if (manualType == "Y") {
            this.showPricing = false;
            this.manualStatus = true;
          } else {
            this.showPricing = true;
            this.manualStatus = false;
            // get uom group uoms
            const self = this;
            this.$store
              .dispatch("get", `/ougp/${val.UgpEntry}`)
              .then(res => {
                self.uomArray = res.ResponseData.groupDef;
              })
              .catch(err => {
                this.$refs.snackbar.show(err, "red");
              });
            // end
          }
        }
      }
      this.record = { ...val };
    },
    checkUom(id) {
      if(id == this.record.IUoMEntry){
        this.uomItem.PackSize = 1;
      } else {
        this.uomItem.PackSize = "";
      }
    },
    openEditModal(data) {
      this.uomItem = data;
      this.editingDialog = true;
    },
    addUom() {
      if(this.record.IUoMEntry == undefined || this.record.IUoMEntry == null){
        this.$refs.snackbar.show("Please select base uom", "red");
        return;
      }

      if(this.record.PUoMEntry == undefined || this.record.PUoMEntry == null){
        this.$refs.snackbar.show("Please select purchase uom", "red");
        return;
      }

      if(this.record.SUoMEntry == undefined || this.record.SUoMEntry == null){
        this.$refs.snackbar.show("Please select sale uom", "red");
        return;
      }

      if(this.uomItem.uomEntry == undefined || this.uomItem.uomEntry == null){
        this.$refs.snackbar.show("Please select unit of measure", "red");
        return;
      }

      if(this.uomItem.BuyingPrice == undefined || this.uomItem.WholesalePrice == undefined || this.uomItem.RetailPrice == undefined || this.uomItem.SellingPrice == undefined || this.uomItem.PackSize == undefined ){
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      var inventoryUom = this.record.IUoMEntry;
      var baseRecord = this.uomArray.find(x => x.uomId == inventoryUom);

      var uomEntry = this.uomItem.uomEntry;
      var uomRecord = this.uom.find(x => x.id == uomEntry);

      if(baseRecord == undefined && uomRecord.id != inventoryUom){
        this.$refs.snackbar.show("Please define uom setup for the base unit first", "red");
        return;
      }

      this.uomItem.uomName = uomRecord.UomName;
      this.uomItem.uomId = uomRecord.id;
      this.uomArray.push(this.uomItem);
      this.uomItem = {};
      this.uomDialog = false;
    },
    addNewUom() {

      if(this.uomArray.length == 0 && this.uomItem.uomEntry != this.record.IUoMEntry){
        this.$refs.snackbar.show("Please define the base unit first", "red");
        return;
      }

      if(this.uomItem.uomEntry == undefined || this.uomItem.uomEntry == null){
        this.$refs.snackbar.show("Please select unit of measure", "red");
        return;
      }

      if(this.uomItem.BuyingPrice == undefined || this.uomItem.WholesalePrice == undefined || this.uomItem.RetailPrice == undefined || this.uomItem.SellingPrice == undefined || this.uomItem.PackSize == undefined ){
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      var uomEntry = this.uomItem.uomEntry;
      var existingRecord = this.uomArray.find(x => x.UomEntry == uomEntry);

      if(existingRecord != undefined){
        this.$refs.snackbar.show("Uom already added", "red");
        return;
      }

      const data = {
        UgpEntry: this.record.UgpEntry,
        UomEntry: this.uomItem.uomEntry,
        AltQty: 1,
        BaseQty: this.uomItem.PackSize,
        BuyingPrice: this.uomItem.BuyingPrice,
        RetailPrice: this.uomItem.RetailPrice,
        WholesalePrice: this.uomItem.WholesalePrice,
        SellingPrice: this.uomItem.SellingPrice,
      };

      const url = "/createugp1";
      this.loader = true;
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if(res['ResultCode'] == 1200){
          location.reload();
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res['ResultDesc'], "red");
          }
          // location.reload();
        })
        .catch(() => {});
    },
    updateDef() {
      let data = this.uomItem;
      const url = "/edit-group-def";
      // const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            location.reload();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            this.loader = false;
          }
        })
        .catch(() => {});
    },
    deleteUom(item) {
      var index = this.uomArray.indexOf(item);
      if (index == -1) {
        return;
      }

      this.uomArray.splice(index, 1);
    },
    categoryModal() {
      this.categoryDialog = true;
    },
    brandModal() {
      this.brandDialog = true;
    },
    saveBrand(data) {
      const url = "/brands";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.brands = [...this.brands, res.ResponseData];
            self.record.brand_id = res.ResponseData.id;
            self.$refs.snackbar.show("Brand Added Successully", "green");
            self.brandDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveCategory(data) {
      const url = "/products-categories";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.categories = [...this.categories, res.ResponseData];
            self.record.i_t_m1_s_id = res.ResponseData.id;
            self.$refs.snackbar.show("Category Added Successully", "green");
            self.$store.commit("btnLoader", false);
            self.categoryDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
        this.loader = true;
        this.$store.commit("btnLoader", true);
        this.record.SerialStatus = "N";
        this.record.ItemType = "I";
        this.record.Taxable = "Y";
        this.record.productType = 1;
        this.record.SellingPrice = 0;
        this.record.uoms = this.uomArray;
        this.$emit("data", this.record);
    },
    updateData() {
      this.loader = true;
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
    setSVolume(id) {
      const data = this.uoms.find(record => {
        return record.UomEntry === id;
      });
      this.record.SVolume = data.BaseQty;
    },
    setSalUnitMsr(id) {
      const data = this.uoms.find(record => {
        return record.UomEntry === id;
      });
      this.record.NumInSale = data.BaseQty;
    },
    setInvntryUom(id) {
      const data = this.uoms.find(record => {
        return record.UomEntry === id;
      });
      this.record.NumInCnt = data.BaseQty;
    },
    setBuyUnitMsr(id) {
      const data = this.uoms.find(record => {
        return record.UomEntry === id;
      });
      this.record.NumInBuy = data.BaseQty;
    },
    CheckUoMGroup(id) {
      const uomGroup = this.ougp.find(record => {
        return record.id === id;
      });
      const self = this;
      if (uomGroup.UgpName === "Manual") {
        self.showPricing = false;
        self.manualStatus = true;
      } else {
        this.loading = true;
        this.$store
          .dispatch("get", `/ougp/${id}`)
          .then(res => {
            self.uoms = res.ResponseData.groupDef;
            self.showPricing = true;
            self.manualStatus = false;
            self.record.SalUnitMsr = null;
            self.loading = false;
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getIndustries() {
      const self = this;
      this.$store
        .dispatch("get", `/industries`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.industries = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getBrands() {
      const self = this;
      this.$store
        .dispatch("get", `/brands`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.brands = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getOugp() {
      const self = this;
      this.$store
        .dispatch("get", `/ougp`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.ougp = res.ResponseData;
            // self.record = { ...self.record, UgpEntry: res.ResponseData[0].id };
            if (self.docCreate == true) {
              self.record.UgpEntry = res.ResponseData[0].id;
              self.record.NumInBuy = 1;
              self.record.NumInSale = 1;
              self.record.NumInBuy = 1;
              // end
              self.showPricing = false;
              self.manualStatus = true;
            }
            // set items per msr
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGeneralSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            // set default store
            if (self.docCreate == true) {
              self.store = res.ResponseData.store_id;
            }
            // set default category
            if (self.record.i_t_m1_s_id == undefined) {
              const brandId = res.ResponseData.defaultBrand;
              const categoryId = res.ResponseData.defaultCategory;
              self.record = {
                ...self.record,
                i_t_m1_s_id: categoryId,
                brand_id: brandId,
                Taxable: "Y"
              };
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.vendors = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUom() {
      const self = this;
      this.$store
        .dispatch("get", `/oums`)
        .then(res => {
          self.uom = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getOwners() {
      const self = this;
      this.$store
        .dispatch("get", `/get-owner-users`)
        .then(res => {
          console.log(res.ResponseData);
          self.owners = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getUom();
    this.getCategories();
    this.getBrands();
    this.getIndustries();
    this.getStores();
    this.getGeneralSettings();
    this.getOugp();
    this.getSuppliers();
    this.getUom();
    this.getOwners();
  }
};
</script>